/**
 * @generated SignedSource<<2b947bd56577721e5aeb4b19270dffd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketingEmailDetailsViewPreviewQuery$variables = {
  language?: string | null | undefined;
  marketingEmailId: string;
};
export type MarketingEmailDetailsViewPreviewQuery$data = {
  readonly marketingEmailPreview: {
    readonly htmlBody: string;
    readonly subject: string;
    readonly textBody: string;
  } | null | undefined;
};
export type MarketingEmailDetailsViewPreviewQuery = {
  response: MarketingEmailDetailsViewPreviewQuery$data;
  variables: MarketingEmailDetailsViewPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "marketingEmailId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      },
      {
        "kind": "Variable",
        "name": "marketingEmailId",
        "variableName": "marketingEmailId"
      }
    ],
    "concreteType": "EmailPreview",
    "kind": "LinkedField",
    "name": "marketingEmailPreview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subject",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "htmlBody",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textBody",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailDetailsViewPreviewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MarketingEmailDetailsViewPreviewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a380e57b1c2a0ac4f3e1c04f17edaf24",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailDetailsViewPreviewQuery",
    "operationKind": "query",
    "text": "query MarketingEmailDetailsViewPreviewQuery(\n  $marketingEmailId: ID!\n  $language: String\n) {\n  marketingEmailPreview(marketingEmailId: $marketingEmailId, language: $language) {\n    subject\n    htmlBody\n    textBody\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea7ce7b832b06242c4c36653031cf3b2";

export default node;
